import downloadIcon from "../assets/res/download_icon.svg";

// ── Offer card used in the "You May Like" horizontal scroll ──
export const OfferCard = ({ offer, onPress }) => (
  <div className="inline-block" onClick={() => onPress(offer)}>
    <div className="relative h-[120px] w-[170px] overflow-hidden rounded-lg shadow-md bg-white hover:shadow-xl transition-shadow duration-300 ease-in-out cursor-pointer">
      <img
        className="h-[120px] w-[170px] object-cover object-center rounded-lg"
        src={offer.picture}
        alt={offer.name_short}
      />
      <div className="absolute top-2 left-2 bg-green-500 text-white text-[10px] semiBold px-2 py-0.5 rounded-full">
        Free
      </div>
      <div className="absolute bottom-0 left-0 flex h-[60px] flex-row z-10 w-full backdrop-blur-2xl bg-light-blue/30">
        <div className="flex flex-col p-2 w-3/4">
          <p className="text-[16px] medium text-white tracking-wider leading-none">
            {offer.name_short}
          </p>
        </div>
        <div className="w-1/4 flex flex-col justify-center items-end mr-2">
          <div className="rounded-full bg-dark-blue flex items-center justify-center h-[36px] w-[36px]">
            <span className="text-white text-xs semiBold">Go</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

// ── Bottom sheet shown when user taps a "You May Like" card ──
const OfferBottomSheet = ({ offer, onClose }) => {
  if (!offer) return null;

  const handleRedirect = () => {
    window.open(offer.link, "_blank");
    onClose();
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-[55] bg-black/50"
        onClick={onClose}
      />

      {/* Sheet */}
      <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md md:max-w-lg z-[60] sheet-enter">
        <div className="bg-white rounded-t-3xl shadow-2xl">

          {/* Drag handle */}
          <div className="flex justify-center pt-3 pb-1">
            <div className="w-10 h-1 bg-gray-200 rounded-full" />
          </div>

          <div className="px-5 pb-8 pt-2">
            {/* Offer image */}
            <img
              src={offer.picture}
              alt={offer.name_short}
              className="w-full h-44 object-cover rounded-2xl"
            />

            {/* Free chip + name */}
            <div className="flex items-center gap-2 mt-4">
              <span className="bg-green-500 text-white text-xs semiBold px-3 py-1 rounded-full">
                Free
              </span>
              <h2 className="semiBold text-gray-900 text-xl flex-1 truncate">
                {offer.name_short}
              </h2>
            </div>

            {/* Ad copy */}
            <p className="medium text-gray-500 text-sm mt-2 leading-relaxed">
              {offer.adcopy}
            </p>

            {/* CTA */}
            <button
              onClick={handleRedirect}
              className="w-full mt-6 py-4 rounded-2xl text-white semiBold text-base bg-gradient-to-r from-semi-blue to-light-blue"
            >
              Get it Free →
            </button>

            {/* Dismiss */}
            <button
              onClick={onClose}
              className="w-full mt-2 py-3 text-gray-400 medium text-sm"
            >
              Not now
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferBottomSheet;
